module.exports = __webpack_public_path__ + "static/operator-and-their-two-screens-25786b6222cfd6a63729084a5fe7b82f.jpg";